"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.explicitVars = exports.explicitCommon = exports.default = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var explicitCommon = exports.explicitCommon = ["width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight"];
var explicitVars = exports.explicitVars = (0, _initVars.default)({
  applied: explicitCommon,
  variables: [{
    key: "blurBackground"
  }, {
    key: "blurLevel"
  }]
});
var explicitStyles = function explicitStyles(theme) {
  return {
    variables: explicitVars.styles,
    root: {
      position: "relative",
      display: "inline-flex",
      borderRadius: "inherit",
      userSelect: "none"
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: 0,
      left: 0,
      // eslint-disable-line @atg/css-rtl-support
      width: "100%",
      height: "100%",
      color: theme.colors.textOnDark,
      borderRadius: "inherit",
      background: explicitVars.get("blurBackground"),
      backdropFilter: explicitVars.get("blurLevel"),
      WebkitBackdropFilter: explicitVars.get("blurLevel"),
      "& svg": {
        fill: theme.colors.textOnDark
      }
    },
    iconOverlay: {
      cursor: "pointer"
    },
    contentOverlay: {
      gap: "".concat(theme.spacing.base * 3, "px")
    },
    textOverlay: {
      gap: "".concat(theme.spacing.base, "px")
    },
    onlyIcon: {
      height: "50%",
      width: "50%",
      maxHeight: theme.spacing.base * 4,
      maxWidth: theme.spacing.base * 4
    },
    iconHeader: {
      height: theme.spacing.base * 4,
      width: theme.spacing.base * 4
    }
  };
};
var useExplicitStyles = (0, _createUseStyles.default)(explicitStyles, {
  name: "Explicit"
});
var _default = exports.default = useExplicitStyles;